import Popper from './popper'

// eslint-disable-next-line import/prefer-default-export
export { Popper }
